define("shared/components/shared/ui/multi-select-button", ["exports", "@ember/component", "@ember/object", "@ember/runloop", "@ember/service", "@glimmer/component", "@glimmer/tracking", "lodash", "shared/utils/uuid", "@ember/template-factory"], function (_exports, _component, _object, _runloop, _service, _component2, _tracking, _lodash, _uuid, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = _exports.MultiSelectButtonComponent = void 0;
  var _class, _descriptor, _descriptor2, _descriptor3, _descriptor4, _descriptor5, _transformDropdownElement, _generateUid;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/runloop",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"lodash",0,"shared/utils/uuid"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
  function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _classPrivateMethodGet(s, a, r) { return _assertClassBrand(a, s), r; }
  function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! @glint-nocheck: not typesafe yet }}
  <div ...attributes class={{concat-classes "o--multiSelectBtn" this.verticalPositionClass}}>
    <Shared::Ui::Button
      @isDisabled={{or @submitDisabled @loading}}
      @onClick={{action this.onClick}}
      @runningText={{t "shared_phrases.please_wait"}}
      class={{@submitBtnClass}}
      data-test-id="multi-select-button-submit"
      type="button"
    >
      {{svg-jar this.selectedOption.icon class="o--icon u--m__r__xs"}}
      {{this.selectedOption.title}}
    </Shared::Ui::Button>
  
    <div
      class={{concat-classes
        "o--multiSelectBtn__trigger"
        (if @selectDisabled "is--disabled")
        (if @triggerBtnClass @triggerBtnClass)
      }}
      data-test-id="multi-select-button-trigger"
    >
      <PowerSelect
        @calculatePosition={{this.calculatePosition}}
        @destination={{this.dropdownId}}
        @disabled={{or @selectDisabled @loading}}
        @dropdownClass="qa--postSchedule_optionsDropdown"
        @horizontalPosition={{this.horizontalPosition}}
        @onChange={{action this.onChange}}
        @onOpen={{@onOpen}}
        @options={{@options}}
        @selected={{this.selectedOption}}
        @triggerClass=""
        @verticalPosition={{this.verticalPosition}}
        id="multi-select-button"
        {{did-update this.useSelectedOption @selectedOption}}
        as |action|
      >
        <div class={{concat-classes "o--dropOptionCard" (if action.class action.class)}}>
          <p class="o--dropOptionCard__title">
            {{svg-jar action.icon class="o--icon u--m__r__xs"}}
            {{action.title}}
          </p>
          <p class="o--dropOptionCard__desc">
            {{#if action.error}}
              <span class="u--text--danger">
                {{action.error}}
              </span>
            {{else}}
              {{action.body}}
            {{/if}}
            {{#if action.needsUpgrade}}
              <span class="u--text--underline u--text--success">
                {{action.upgradeMessage}}
              </span>
            {{/if}}
          </p>
        </div>
      </PowerSelect>
    </div>
    {{yield}}
    <div class="o--multiSelectBtn__dropdown" data-test-id="multi-select-button-dropdown" id={{this.dropdownId}}></div>
  </div>
  */
  {
    "id": "s/Gqpxsj",
    "block": "[[[11,0],[17,1],[16,0,[28,[37,0],[\"o--multiSelectBtn\",[30,0,[\"verticalPositionClass\"]]],null]],[12],[1,\"\\n  \"],[8,[39,1],[[16,0,[30,2]],[24,\"data-test-id\",\"multi-select-button-submit\"],[24,4,\"button\"]],[[\"@isDisabled\",\"@onClick\",\"@runningText\"],[[28,[37,2],[[30,3],[30,4]],null],[28,[37,3],[[30,0],[30,0,[\"onClick\"]]],null],[28,[37,4],[\"shared_phrases.please_wait\"],null]]],[[\"default\"],[[[[1,\"\\n    \"],[1,[28,[35,5],[[30,0,[\"selectedOption\",\"icon\"]]],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n    \"],[1,[30,0,[\"selectedOption\",\"title\"]]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n  \"],[10,0],[15,0,[28,[37,0],[\"o--multiSelectBtn__trigger\",[52,[30,5],\"is--disabled\"],[52,[30,6],[30,6]]],null]],[14,\"data-test-id\",\"multi-select-button-trigger\"],[12],[1,\"\\n    \"],[8,[39,7],[[24,1,\"multi-select-button\"],[4,[38,8],[[30,0,[\"useSelectedOption\"]],[30,9]],null]],[[\"@calculatePosition\",\"@destination\",\"@disabled\",\"@dropdownClass\",\"@horizontalPosition\",\"@onChange\",\"@onOpen\",\"@options\",\"@selected\",\"@triggerClass\",\"@verticalPosition\"],[[30,0,[\"calculatePosition\"]],[30,0,[\"dropdownId\"]],[28,[37,2],[[30,5],[30,4]],null],\"qa--postSchedule_optionsDropdown\",[30,0,[\"horizontalPosition\"]],[28,[37,3],[[30,0],[30,0,[\"onChange\"]]],null],[30,7],[30,8],[30,0,[\"selectedOption\"]],\"\",[30,0,[\"verticalPosition\"]]]],[[\"default\"],[[[[1,\"\\n      \"],[10,0],[15,0,[28,[37,0],[\"o--dropOptionCard\",[52,[30,10,[\"class\"]],[30,10,[\"class\"]]]],null]],[12],[1,\"\\n        \"],[10,2],[14,0,\"o--dropOptionCard__title\"],[12],[1,\"\\n          \"],[1,[28,[35,5],[[30,10,[\"icon\"]]],[[\"class\"],[\"o--icon u--m__r__xs\"]]]],[1,\"\\n          \"],[1,[30,10,[\"title\"]]],[1,\"\\n        \"],[13],[1,\"\\n        \"],[10,2],[14,0,\"o--dropOptionCard__desc\"],[12],[1,\"\\n\"],[41,[30,10,[\"error\"]],[[[1,\"            \"],[10,1],[14,0,\"u--text--danger\"],[12],[1,\"\\n              \"],[1,[30,10,[\"error\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],[[[1,\"            \"],[1,[30,10,[\"body\"]]],[1,\"\\n\"]],[]]],[41,[30,10,[\"needsUpgrade\"]],[[[1,\"            \"],[10,1],[14,0,\"u--text--underline u--text--success\"],[12],[1,\"\\n              \"],[1,[30,10,[\"upgradeMessage\"]]],[1,\"\\n            \"],[13],[1,\"\\n\"]],[]],null],[1,\"        \"],[13],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[10]]]]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[18,11,null],[1,\"\\n  \"],[10,0],[14,0,\"o--multiSelectBtn__dropdown\"],[14,\"data-test-id\",\"multi-select-button-dropdown\"],[15,1,[30,0,[\"dropdownId\"]]],[12],[13],[1,\"\\n\"],[13]],[\"&attrs\",\"@submitBtnClass\",\"@submitDisabled\",\"@loading\",\"@selectDisabled\",\"@triggerBtnClass\",\"@onOpen\",\"@options\",\"@selectedOption\",\"action\",\"&default\"],false,[\"concat-classes\",\"shared/ui/button\",\"or\",\"action\",\"t\",\"svg-jar\",\"if\",\"power-select\",\"did-update\",\"yield\"]]",
    "moduleName": "shared/components/shared/ui/multi-select-button.hbs",
    "isStrictMode": false
  });
  const ELEMENT_UID_PREFIX = 'multi-select-button';
  const ELEMENT_CSS_CLASS = 'o--multiSelectBtn';
  let MultiSelectButtonComponent = _exports.MultiSelectButtonComponent = (_class = (_transformDropdownElement = /*#__PURE__*/new WeakSet(), _generateUid = /*#__PURE__*/new WeakSet(), class MultiSelectButtonComponent extends _component2.default {
    constructor(owner, args) {
      super(owner, args);

      // TODO: Better error handling
      _classPrivateMethodInitSpec(this, _generateUid);
      _classPrivateMethodInitSpec(this, _transformDropdownElement);
      _initializerDefineProperty(this, "seamlessCheckoutManager", _descriptor, this);
      /**
       * Unique identifier for this element
       */
      _initializerDefineProperty(this, "uid", _descriptor2, this);
      /**
       * Selected option from the dropdown to use with the action button
       */
      _initializerDefineProperty(this, "selectedOption", _descriptor3, this);
      _initializerDefineProperty(this, "verticalPosition", _descriptor4, this);
      _initializerDefineProperty(this, "horizontalPosition", _descriptor5, this);
      _defineProperty(this, "dropdownInlineStyleObject", {
        // Note: we're better off using a percentage unit of the dropdown's height for this
        top: '0%',
        // Note: because we want to offset horizontally by a specific amount, we use `px` unit for this
        left: '0px'
      });
      if (!this.args.options?.length) {
        throw new Error('Missing required `options` array argument');
      }
      this.selectedOption = this.args.selectedOption ?? this.args.options[0];
      if (this.args.uid) {
        this.uid = this.args.uid;
      } else {
        this.uid = _classPrivateMethodGet(this, _generateUid, _generateUid2).call(this);
      }
    }

    /**
     * Identifier string generated for assigning as our "destination" element's `id`
     * attribute in the DOM - which we use to place the dropdown's content in.
     */
    get dropdownId() {
      return `${ELEMENT_UID_PREFIX}_dropdown-${this.uid}`;
    }
    get cssClass() {
      return ELEMENT_CSS_CLASS;
    }
    get verticalPositionClass() {
      if (this.verticalPosition === 'above') {
        return `${this.cssClass}--above`;
      }
      return `${this.cssClass}--below`;
    }
    async onChange(action) {
      if (action.value === 'draft' && action.needsUpgrade) {
        const feature = 'draftPosts';
        const location = 'post modal draft save';
        return this.seamlessCheckoutManager.upgrade({
          feature,
          location
        });
      }
      this.selectedOption = action;
      if ((0, _lodash.isFunction)(this.args.onChange)) {
        this.args.onChange(this.selectedOption);
      }
    }
    onClick() {
      if ((0, _lodash.isFunction)(this.args.onClick)) {
        this.args.onClick(this.selectedOption);
      }
    }
    calculatePosition(_trigger, _content, destination, _ref) {
      let {
        verticalPosition,
        horizontalPosition
      } = _ref;
      const dropdownContent = destination.querySelector('.ember-basic-dropdown-content');
      if (!dropdownContent) {
        throw new Error('Unable to query selector for dropdown content');
      }
      const {
        innerWidth,
        innerHeight
      } = window;
      const domRect = dropdownContent.getBoundingClientRect();
      const x = Math.ceil(domRect.x);
      const y = Math.ceil(domRect.y);
      const {
        width,
        height
      } = domRect;
      const hasOverflowX = x + width >= innerWidth;
      const hasOverflowY = y + height >= innerHeight;

      // Note: make sure the right-side of the dropdown isn't flowing offscreen
      const paddingX = 16;
      const overflowCorrectionX = hasOverflowX ? `-${paddingX + x + width - innerWidth}px` : `0px`;

      // Note: make sure bottom of dropdown isn't flowing offscreen
      const overflowCorrectionY = hasOverflowY ? '-100%' : '0%';
      (0, _runloop.schedule)('render', this, function () {
        _classPrivateMethodGet(this, _transformDropdownElement, _transformDropdownElement2).call(this, dropdownContent, {
          hasOverflowX,
          hasOverflowY,
          translateX: overflowCorrectionX,
          translateY: overflowCorrectionY,
          verticalPosition,
          horizontalPosition
        });
      });

      // Note: we just need to return an empty object here because we don't care about
      // modifying the component's position props as much as our own, CSS-based calculations
      return {};
    }
    useSelectedOption() {
      const optionValue = this.args.selectedOption;
      const multiSelectButtonElement = document.getElementById('multi-select-button');
      if (!optionValue || !multiSelectButtonElement) {
        return;
      }
      this.selectedOption = optionValue;
      const changeEvent = new Event('change');
      multiSelectButtonElement.dispatchEvent(changeEvent);
    }
  }), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "seamlessCheckoutManager", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "uid", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor3 = _applyDecoratedDescriptor(_class.prototype, "selectedOption", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor4 = _applyDecoratedDescriptor(_class.prototype, "verticalPosition", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'above';
    }
  }), _descriptor5 = _applyDecoratedDescriptor(_class.prototype, "horizontalPosition", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return 'left';
    }
  }), _applyDecoratedDescriptor(_class.prototype, "onChange", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onChange"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "onClick", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "onClick"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "calculatePosition", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "calculatePosition"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "useSelectedOption", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "useSelectedOption"), _class.prototype)), _class);
  function _transformDropdownElement2(element, options) {
    const {
      hasOverflowX,
      hasOverflowY,
      translateX,
      translateY,
      verticalPosition
    } = options;
    if (hasOverflowX) {
      this.dropdownInlineStyleObject.left = translateX;
    }
    if (hasOverflowY) {
      this.dropdownInlineStyleObject.top = translateY;
      if (verticalPosition === 'below') {
        this.verticalPosition = 'above';
      }
    }
    const {
      top,
      left
    } = this.dropdownInlineStyleObject;
    element.setAttribute('style', `left: ${left} !important; top: ${top} !important`);
  }
  function _generateUid2() {
    return (0, _uuid.default)();
  }
  var _default = _exports.default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, MultiSelectButtonComponent);
});